import { createGlobalStyle } from 'styled-components'

const baseUrl = process.env.REACT_APP_COLLECT_URL

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Pretendard';
    font-weight: 400;
    src: url('${baseUrl}/fonts/Pretendard-Regular.woff2') format('woff2'),
    url('${baseUrl}/fonts/Pretendard-Regular.ttf') format('truetype');
    font-display: fallback;
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 500;
    src: url('${baseUrl}/fonts/Pretendard-Medium.woff2') format('woff2'),
    url('${baseUrl}/fonts/Pretendard-Medium.ttf') format('truetype');
    font-display: fallback;
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 700;
    src: url('${baseUrl}/fonts/Pretendard-Bold.woff2') format('woff2'),
    url('${baseUrl}/fonts/Pretendard-Bold.ttf') format('truetype');
    font-display: fallback;
  }

  .sauceflex_collection {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-overflow-scrolling: touch;
    user-select: none;
    -ms-overflow-style: none;
    -webkit-text-size-adjust: none;
    font-size: 14px;
    font-family: 'Pretendard', sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue' !important;
    
    button {
      font-family: 'Pretendard', sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue' !important;
    }

    a {
      text-decoration: none;
      color: inherit;
    }

    *:not(.scrollbar)::-webkit-scrollbar {
      background-color: transparent;
      display: none;
    }

    * {
      scroll-behavior: smooth;
      box-sizing: border-box;
    }

    *::-webkit-media-controls-start-playback-button {
      display: none !important;
      -webkit-appearance: none;
    }

    *:-webkit-autofill,
    *:-webkit-autofill:hover,
    *:-webkit-autofill:focus,
    *:-webkit-autofill:active {
      /* if input has one color, and didn't have bg-image use shadow */
      -webkit-box-shadow: 0 0 0 1000px #fff inset;
    }

    width: 100%;
    background-color: ${(props) => props.theme.background};
    color: ${(props) => props.theme.font.primary};

    button {
      color: #000;
    }

    [tabIndex='0']:focus-visible {
      border: 2px solid rgb(98, 102, 207);
    }
    button:focus-visible {
      outline: 2px solid rgb(98, 102, 207);
    }
  }
`
